module.exports = __webpack_public_path__ + "img/ai.995c4520.svg";